import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Nav, NavItem, NavLink, Row, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import classnames from "classnames";
import '../../../i18/config';
import {useTranslation} from "react-i18next";
import {useHistory, useRedux, useSearchInput} from "../../../hooks";

import {ProductStatus, ProductType} from "../../../redux/Sale/Product/types";
import {
    copyProduct,
    groupIntegrationModalShow, groupRemoveProductsModalShow, onRemoveSaleProduct,
    removeSaleProductModalHide,
    removeSaleProductModalShow, setGroupProductsModalShow, unSetGroupProductsModalShow
} from "../../../redux/Sale/Product/actions";
import Loader from "../../../components/Loader"
import * as route from "../../../api/routes";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import {getIsNeedRefresh, removeIsNeedRefresh} from "../../../helpers/functions";
import SaleProductColumns from "./tableColumns";
import {EntityActionsHandlersType} from "../../../redux/types";
import TableList from "../../../components/TableList";
import {setHistoryHash as setHistoryHashFunc} from "../../../helpers/functions";
import RemoveModal from "../../../components/RemoveForm";
import {LicenseProductParam} from "../../../redux/Sale/License/types";
import UpgradeFarePage from "../../../components/UpgradeFarePage";
import RightModal from "../Category/modalForm";
import {
    editDataSaleCategory,
    showRightModalSaleCategory
} from "../../../redux/Sale/Category/actions";
import {
    getSaleProducts,
} from "../../../redux/Sale/Product/actions";
import {SaleStoreType} from "../../../redux/Sale/Store/types";
import {CurrencyType} from "../../../redux/Sale/Currency/types";
import {PriceTypeType} from "../../../redux/Sale/PriceType/types";
import {ContentPeerChannelType} from "../../../redux/Content/PeerChannel/types";
import {getSaleStores} from "../../../redux/Sale/Store/actions";
import {getSaleCurrencies} from "../../../redux/Sale/Currency/actions";
import {getSalePriceTypes} from "../../../redux/Sale/PriceType/actions";
import {getContentPeerChannels} from "../../../redux/Content/PeerChannel/actions";
import RightModalGroupIntegration from "./modalGroupIntegrationForm";
import MainListFilter from "../../../components/MainListFilter";
import {getSaleProductParams} from "../../../redux/Sale/ProductParam/actions";
import GroupProductsModal from "./GroupProductsModal";
import {useFareRestriction} from "../../../hooks/useFareRestriction";
import {SaleIntegrationType} from "../../../redux/Sale/Integration/types";
import {getSaleIntegrations} from "../../../redux/Sale/Integration/actions";
import DeleteProductsModal from "./DeleteProductsModal";
import {TicketStatus} from "../../../redux/Support/Ticket/types";

const SaleProductIndex = () => {

    const { t } = useTranslation(['common']);
    const { dispatch, useAppSelector } = useRedux();

    const componentType = 'saleProductItemsType';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getSaleProducts,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const [selectedItems, setSelectedItems] = useState<ProductType[]>([]);

    const [activeTab, setActiveTab] = useState("All");
    const [isLoaded, setLoaded] = useState<boolean>(false);
    const [stores, setStores] = useState<SaleStoreType[]>([]);
    const [currencies, setCurrencies] = useState<CurrencyType[]>([]);
    const [priceTypes, setPriceTypes] = useState<PriceTypeType[]>([]);
    const [channels, setChannels] = useState<ContentPeerChannelType[]>([]);
    const [isGroupActionReady, setGroupActionReady] = useState<boolean>(false);
    const [saleIntegrations, setSaleIntegrations] = useState<SaleIntegrationType[]>([]);

    const {
        saleProduct,
        isFetched,
        saleStore,
        saleCurrency,
        salePriceType,
        contentPeerChannels,
        salePlan,
        saleProductParam,
        saleIntegration
    } = useAppSelector(state => ({
        isFetched: state.SaleProduct.isFetched,
        saleProduct: state.SaleProduct,
        saleStore: state.SaleStore,
        saleCurrency: state.SaleCurrency,
        salePriceType: state.SalePriceType,
        contentPeerChannels: state.ContentPeerChannel,
        salePlan: state.SalePlan,
        saleProductParam: state.SaleProductParam,
        saleIntegration: state.SaleIntegration
    }));

    const { upgradeFare } = useFareRestriction(salePlan?.currentPlan, LicenseProductParam.SALE_MAX_PRODUCTS);


    const [products, setProducts] = useState<ProductType[]>([]);

    useEffect(() => {
        dispatch(getSaleStores({maxResults:1000}));
        dispatch(getSaleCurrencies({maxResults:1000}));
        dispatch(getSalePriceTypes({maxResults:1000}));
        dispatch(getSaleProductParams({maxResults: 1000}));
        dispatch(getSaleIntegrations({maxResults: 1000}));
        dispatch(getContentPeerChannels());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (isFetched) {
            setLoaded(isFetched);
        }
    }, [isFetched]);

    const checkIsAllFetched = () => {
        if (
            saleStore.isFetched
            &&
            saleCurrency.isFetched
            &&
            salePriceType.isFetched
            &&
            contentPeerChannels.isFetched
            &&
            saleProductParam.isFetched
            &&
            saleIntegration.isFetched
        ){
            setGroupActionReady(true);
        }
    }

    useEffect(() => {

        if (saleStore?.items && (saleStore?.items || []).length>0){
            setStores([...saleStore.items]);
        } else {
            setStores([]);
        }

        checkIsAllFetched();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saleStore?.items]);

    useEffect(() => {

        if (contentPeerChannels?.items && (contentPeerChannels?.items || []).length>0){
            setChannels([...contentPeerChannels.items]);
        } else {
            setChannels([]);
        }

        checkIsAllFetched();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentPeerChannels?.items]);

    useEffect(() => {

        if (saleIntegration?.items && (saleIntegration?.items || []).length>0){
            setSaleIntegrations([...saleIntegration.items]);
        } else {
            setSaleIntegrations([]);
        }

        checkIsAllFetched();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saleIntegration?.items]);

    useEffect(() => {

        if (saleCurrency?.items && (saleCurrency?.items || []).length>0){
            setCurrencies([...saleCurrency.items]);
        } else {
            setCurrencies([]);
        }
        checkIsAllFetched();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saleCurrency?.items]);

    useEffect(() => {

        if (salePriceType?.items && (salePriceType?.items || []).length>0){
            setPriceTypes([...salePriceType.items]);
        } else {
            setPriceTypes([]);
        }
        checkIsAllFetched();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salePriceType?.items]);

    useEffect(() => {
        if (saleProduct.isNeedReload){
            loadItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, saleProduct.isNeedReload]);

    useEffect(() => {

        if ((saleProduct.items !== undefined) && (saleProduct.items.length>0)){
            setProducts([...saleProduct.items]);
        } else {
            setProducts([]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saleProduct?.items])

    const toggleClickTab = (tab) => {
        if (activeTab !== tab) {
            if ( historyHash.tab !== tab) {
                historyHash.tab = tab;
                historyHash.page = 1;

                switch (historyHash.tab) {
                    case "Final": historyHash.status = TicketStatus.FINAL.status; break;
                    case "New": historyHash.status = ProductStatus.NEW.status; break;
                    case "All": historyHash.status = undefined; break;
                }

                setActiveTab(tab);
                setHistoryHashFunc(historyHash);
            }
        }
    }

    const onTableRowClick = (item:ProductType) => {
        window.location.href = route.SALE_PRODUCT_DETAIL.replace(/:uuid/g, item.uuid);
    }

    const onHandleEdit = (item:ProductType) => {
        window.location.href = route.SALE_PRODUCT_DETAIL_EDIT.replace(/:uuid/g, item.uuid);
    }
    const handleCopy = (currentItem:ProductType) =>{
        dispatch(copyProduct(currentItem));
    }

    const handleRemove = (currentItem:ProductType) =>{
        dispatch(removeSaleProductModalShow({data:Object(currentItem), modalEditTitle:'deleteProduct'}));
    }

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onDetail: onTableRowClick,
        onCopy: handleCopy,
        onRemove: handleRemove,
        onEdit: onHandleEdit,
    }

    const ProductOnRemove = (event:any, dispatch:any) => {

        if ((event !== undefined && event.uuid !==undefined && event.uuid.length>0)){
            dispatch(onRemoveSaleProduct({data:event, modalEditTitle: 'deleteProduct'}));
        }
    }

    const ProductHideRemoveModal = (dispatch:any) => {
        dispatch(removeSaleProductModalHide())
    }

    const openRightModalProductCategory = (event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(editDataSaleCategory({data:event, modalEditTitle: 'changeCategory'}));
        } else {
            dispatch(showRightModalSaleCategory({data:[], modalEditTitle: 'newCategory'}));
        }
    };

    const openRightModalGroupIntegration = () => {
        dispatch(groupIntegrationModalShow());
    };

    const handleGroupActionSelectItems = (items:any[]) => {
        setSelectedItems(items);
    }

    const columns = SaleProductColumns({...EntityActionsHandlers});

    const handleSetGroupAction = () =>{
        dispatch(setGroupProductsModalShow());
    }
    const handleUnSetGroupAction = () =>{
        dispatch(unSetGroupProductsModalShow());
    }
    const handleRemoveGroupAction = () =>{
        dispatch(groupRemoveProductsModalShow());
    }

    if (getIsNeedRefresh()){
        removeIsNeedRefresh();
        loadItems();
    }

    return (
        <>
            <BreadCrumb title={t('menu:products')} pageTitle={t('menu:main')} />

            { upgradeFare && isFetched ?
                <>
                    <div className="d-flex flex-row flex-grow-1">
                        <div className="alert alert-danger alert-border-left alert-dismissible fade show d-flex flex-row flex-grow-1" role="alert">
                            <i className="ri-error-warning-line me-2 align-middle"></i> <strong className="pe-2">{t('common:attention')}!</strong>{t('plan:restrictionProductsText')}
                        </div>
                    </div>
                    <UpgradeFarePage/>
                </>
                :
                <>
            <Row>
                <Col lg={12}>
                    <Card id="productList">
                        <CardHeader className="card-header border-bottom-0">
                            <Row className="align-items-center gy-3">
                                <div className="col-sm">
                                    <div className="d-flex flex-shrink-0">
                                        <UncontrolledButtonDropdown id="btnGroupVerticalDrop1">
                                            <DropdownToggle color="success" caret>
                                                <i className="ri-add-line align-bottom me-1 font-weight-normal"/>
                                                {t('common:addNew')}
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem href={route.SALE_PRODUCT_DETAIL_EDIT.replace(/:uuid/,'new')}>
                                                    {t('product:product')}
                                                </DropdownItem>
                                                <DropdownItem onClick={openRightModalProductCategory}>{t('category:category')}</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                    </div>
                                </div>
                                <div className="col-sm text-end">
                                    <button type="button" className="btn btn-soft-primary me-2"><i
                                        className="ri-download-cloud-2-line align-bottom me-1"/> Import
                                    </button>
                                    <button type="button" className="btn btn-soft-primary"><i
                                        className="ri-upload-cloud-2-line align-bottom me-1"/> Export
                                    </button>
                                </div>
                            </Row>
                        </CardHeader>
                        <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                            <MainListFilter
                                onClick={handleSearchClick}
                                value={searchPhrase}
                                onChange={onSearchInput}
                            />
                        </CardBody>
                    <CardBody className="pt-0">
                        <div>
                            <Nav
                                className="nav-tabs nav-tabs-custom nav-success"
                                role="tablist"
                            >
                                <NavItem>
                                    <NavLink
                                        className={classnames(
                                            { active: activeTab === "All" },
                                            "fw-semibold"
                                        )}
                                        onClick={() => {
                                            toggleClickTab( "All");
                                        }}
                                        href="#"
                                    >
                                        <i className="ri-shopping-cart-2-line me-1 align-bottom font-weight-normal"/>{" "}
                                        {t('product:allProducts')}
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames(
                                            { active: activeTab === "Final" },
                                            "fw-semibold"
                                        )}
                                        onClick={() => {
                                            toggleClickTab("Final");
                                        }}
                                        href="#"
                                    >
                                        <i className="ri-checkbox-circle-line me-1 align-bottom font-weight-normal"/>{" "}
                                        {t('product:activeProducts')}
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames(
                                            { active: activeTab === "New" },
                                            "fw-semibold"
                                        )}
                                        onClick={() => {
                                            toggleClickTab("New");
                                        }}
                                        href="#"
                                    >
                                        <i className="ri-edit-box-line me-1 align-bottom font-weight-normal"/>{" "}
                                        {t('product:draftProducts')}
                                    </NavLink>
                                </NavItem>
                                <NavItem className="d-flex flex-row flex-nowrap flex-grow-1 justify-content-end pt-1 pb-1">
                                    <div className="d-flex flex-shrink-0">
                                        {((selectedItems && (selectedItems.length>0)) || (historyHash?.allGroupActionSelect && historyHash.allGroupActionSelect === true)) &&
                                        <UncontrolledButtonDropdown id="btnGroupVerticalAction">
                                            <DropdownToggle
                                                caret
                                                className={"btn-sm btn-soft-primary"}
                                                disabled={!(selectedItems && (selectedItems.length>0)) && !isGroupActionReady && !(historyHash?.allGroupActionSelect && historyHash.allGroupActionSelect === true)}
                                            >
                                                <i className="ri-checkbox-multiple-line align-bottom me-1 font-weight-normal"/>
                                                {t('common:groupAction')}{" "}(
                                                {historyHash?.allGroupActionSelect && historyHash.allGroupActionSelect === true
                                                    ?
                                                        saleProduct?.meta?.totalCount > 0 ? saleProduct?.meta?.totalCount : ''
                                                    :
                                                        selectedItems.length
                                                })
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem onClick={openRightModalGroupIntegration}>{t('integration:integrations')}</DropdownItem>
                                                <DropdownItem onClick={handleSetGroupAction}>{t('common:groupItems')}</DropdownItem>
                                                <DropdownItem onClick={handleUnSetGroupAction}>{t('common:ungroupItems')}</DropdownItem>
                                                <DropdownItem onClick={handleRemoveGroupAction}>{t('common:delete')}</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                        }
                                    </div>

                                </NavItem>
                            </Nav>
                            {isLoaded ?
                                    <TableList
                                        columns={columns}
                                        data={products || []}
                                        onRowClick={onTableRowClick}
                                        key={componentType}
                                        historyHash = {historyHash}
                                        selectableRows = {true}
                                        handleGroupActionSelectItems = {handleGroupActionSelectItems}
                                        paginationTotalRows={saleProduct?.meta?.totalCount || 0}
                                        paginationServer={true}
                                        isShowChangePageSize={true}
                                        isShowAllGroupAction={true}
                                    />
                                :
                                <Loader />
                            }
                        </div>
                    </CardBody>
                    </Card>
                </Col>
            </Row>
            <RightModal/>
                    <RightModalGroupIntegration
                        stores={stores}
                        currencies={currencies}
                        priceTypes={priceTypes}
                        channels={channels}
                        products={selectedItems}
                        historyHash={historyHash}
                        integrations={saleIntegrations}
                    />
            <RemoveModal
                onRemove={ProductOnRemove}
                handleClose={ProductHideRemoveModal}
                removeItem={saleProduct.selectedItem}
                isOpen={saleProduct.removeModalShow}
                modalTitle={saleProduct.modalEditTitle}/>
            <GroupProductsModal
                products={selectedItems}
                historyHash={historyHash}
                isOpen={saleProduct.isModalGroupProductsShow}
                    />
             <DeleteProductsModal
                 products={selectedItems}
                 historyHash={historyHash}
                 isOpen={saleProduct.isModalGroupRemoveProductsShow}
             />
            </>
            }
        </>
    );
};

export default SaleProductIndex;


